// extracted by mini-css-extract-plugin
export default {"nameCell":"AttendeesTable_nameCell__58Ty7"};